<template>
  <div>
    <table v-if="days.length > 0" class="schedule-table">
        <thead>
          <tr>
            <th class="day-column text-center">Den</th>
            <th class="text-center">Časy zobrazování</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="day in days" :key="day.index" class="table-row">
            <td class="text-center">{{day.name}}</td>
            <td>
              <IntervalPicker 
                :key="getAllDayInitialValue(day.index) ? `picker-${day.index}-all-day` : `picker-${day.index}`"
                :dayOfWeek="day.index"
                v-on:intervalsChanged="(value) => updateSchedule(day.index, value)"
                :initialValues="getIntervalInitialValues(day.index)"
                :allDayInitial="getAllDayInitialValue(day.index)">
              </IntervalPicker>
            </td>
          </tr>
        </tbody>
    </table>
  </div>
</template>

<script setup>
  import IntervalPicker from './IntervalPicker';
  import _ from "lodash";
  import {ref, watch} from "vue";

  const props = defineProps({
    initialValues: Array,
    daysOfWeek: Array
  })
  const emit = defineEmits(['dateChanged', 'scheduleChanged'])

  const days = ref(props.daysOfWeek ? props.daysOfWeek : [])
  const schedule = ref(props.initialValues ? props.initialValues : [])

  function getIntervalInitialValues(dayOfWeek) {
    return props.initialValues ? props.initialValues.filter(item => item.dayOfWeek === dayOfWeek && (item.timeFrom !== '00:00' || item.timeTo !== '23:59')) : [];
  }

  function getAllDayInitialValue(dayOfWeek) {
    return props.initialValues && !!props.initialValues.find(item => item.dayOfWeek === dayOfWeek && item.timeFrom === '00:00' && item.timeTo === '23:59')
  }

  function setValue(value) {
    schedule.value = value
  }

  function updateSchedule(dayOfWeek, schedulePar) {
    // convert item from schedule to raw value (remove proxy)
    schedule.value = schedule.value.map(item => ({ ...item })).filter(item => item.dayOfWeek !== dayOfWeek).concat(schedulePar)
  }

  watch(schedule, (newSchedule) => {
    _.isEqual(props.initialValues, newSchedule) || emit('scheduleChanged', newSchedule);
  })
  watch(() => props.daysOfWeek, (newDaysOfWeek) => {
    days.value = newDaysOfWeek
    const indexes = days.value.map((day) => day.index)
    schedule.value = schedule.value.filter(item => indexes.includes(item.dayOfWeek))
  })

  defineExpose({setValue})

</script>

<style scoped>
  .schedule-table {
    border: 1px solid #E0E0E1;
    width: 100%;
  }

  thead {
    border: none;
    background: #E0E0E1;
  }

  .table-row {
    border: 1px solid #F5F5F5
  }

  .day-column {
    max-width: 50px;
    min-width: 35px
  }
</style>